import React from "react";

const Footer = () => {
  return (
    <footer className="mt-auto border-t border-border bg-card text-muted-foreground">
      <div className="max-w-7xl mx-auto px-4 py-6 text-sm flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        {/* Left */}
        <div className="text-center md:text-left">
          © {new Date().getFullYear()}{" "}
          <span className="font-medium text-foreground">ImmoIQ</span>
          <div className="text-xs mt-1">Analyse immobilière assistée par IA</div>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-4 text-xs">
          <a href="/terms" className="hover:text-foreground transition">
            Conditions d’utilisation
          </a>
          <a href="/privacy" className="hover:text-foreground transition">
            Politique de confidentialité
          </a>
          <a href="/legal" className="hover:text-foreground transition">
            Avertissement légal
          </a>
          <a href="/contact" className="hover:text-foreground transition">
            Contact
          </a>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="px-4 pb-4 text-[11px] text-center text-muted-foreground max-w-5xl mx-auto">
        Les analyses fournies par ImmoIQ sont offertes à titre informatif seulement et ne constituent pas
        un avis financier, juridique ou fiscal. Toute décision d’investissement demeure la responsabilité
        de l’utilisateur.
      </div>
    </footer>
  );
};

export default Footer;
